(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const normalizePath = (value) => {
      if (!value) return '';

      try {
        const url = new URL(value, window.location.origin);
        return (url.pathname || '/').replace(/\/+$/, '').toLowerCase() || '/';
      } catch (error) {
        return String(value).split('?')[0].replace(/\/+$/, '').toLowerCase() || '/';
      }
    };

    const getMenuTitle = (menuItem) => {
      if (!menuItem) return '';

      const text = Array.from(menuItem.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => node.textContent.trim())
        .filter(Boolean)
        .join(' ');

      if (text) return text.replace(/\s+/g, ' ').trim().toLowerCase();

      const label = menuItem.querySelector(':scope > .orl-mobile-menu-label');
      if (label && label.textContent.trim()) {
        return label.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      }

      return '';
    };

    const addMobileMenuImages = () => {
      if (window.innerWidth >= 990) return;

      const config = document.querySelector('.orl-mobile-menu-images-config');
      if (!config) return;

      const imageMap = new Map();
      const titleMap = new Map();

      config.querySelectorAll('[data-menu-link][data-menu-image]').forEach((item) => {
        const menuLink = normalizePath(item.getAttribute('data-menu-link'));
        const menuImage = item.getAttribute('data-menu-image');
        const menuTitle = (item.getAttribute('data-menu-title') || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        if (menuLink && menuImage) {
          imageMap.set(menuLink, menuImage);
        }

        if (menuTitle && item.getAttribute('data-menu-link')) {
          titleMap.set(menuTitle, item.getAttribute('data-menu-link'));
        }
      });

      if (!imageMap.size) return;

      document.querySelectorAll('.menu-drawer .menu-drawer__menu-item').forEach((menuItem) => {
        if (menuItem.dataset.orlMobileImageApplied === 'true') return;

        let menuUrl = '';

        // Normal child menu item.
        if (menuItem.matches('a') && menuItem.href) {
          menuUrl = menuItem.href;
        }

        // A link nested directly inside the menu item.
        if (!menuUrl) {
          const directLink = menuItem.querySelector(':scope > a');
          if (directLink && directLink.href) {
            menuUrl = directLink.href;
          }
        }

        // Parent menu item supplied by the updated header-drawer.liquid.
        if (!menuUrl) {
          menuUrl = menuItem.getAttribute('data-menu-url') || '';
        }

        // Parent menu fallback: use its title to find the configured URL.
        if (!menuUrl) {
          const title = getMenuTitle(menuItem);
          menuUrl = titleMap.get(title) || '';
        }

        const normalizedUrl = normalizePath(menuUrl);
        const imageUrl = imageMap.get(normalizedUrl);

        if (!imageUrl) return;

        const image = document.createElement('img');
        image.className = 'orl-mobile-menu-image';
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.setAttribute('aria-hidden', 'true');

        /*
         * Set the dimensions inline because Dawn/Shopify theme image
         * rules can override section CSS. The size is responsive:
         * 64px minimum, 22vw on phones, 96px maximum.
         */
        const imageSize = 'clamp(34px, 10vw, 44px)';
        image.style.setProperty('width', imageSize, 'important');
        image.style.setProperty('height', imageSize, 'important');
        image.style.setProperty('min-width', imageSize, 'important');
        image.style.setProperty('max-width', imageSize, 'important');
        image.style.setProperty('min-height', imageSize, 'important');
        image.style.setProperty('max-height', imageSize, 'important');
        image.style.setProperty('aspect-ratio', '1 / 1', 'important');
        image.style.setProperty('object-fit', 'cover', 'important');
        image.style.setProperty('object-position', 'center', 'important');
        image.style.setProperty('display', 'block', 'important');
        image.style.setProperty('flex', '0 0 ' + imageSize, 'important');
        image.style.setProperty('border-radius', '50%', 'important');
        image.style.setProperty('overflow', 'hidden', 'important');
        image.style.setProperty('margin', '0', 'important');

        const label = document.createElement('span');
        label.className = 'orl-mobile-menu-label';

        const textNodes = Array.from(menuItem.childNodes).filter((node) =>
          node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );

        textNodes.forEach((node) => {
          label.appendChild(document.createTextNode(node.textContent.trim()));
          node.remove();
        });

        if (!label.textContent.trim()) {
          const existingLabel = menuItem.querySelector('.orl-mobile-menu-label');
          if (existingLabel) {
            label.textContent = existingLabel.textContent.trim();
            existingLabel.remove();
          }
        }

        menuItem.insertBefore(image, menuItem.firstChild);
        menuItem.insertBefore(label, image.nextSibling);
        menuItem.classList.add('orl-mobile-menu-image-item');

        menuItem.style.setProperty('display', 'flex', 'important');
        menuItem.style.setProperty('align-items', 'center', 'important');
        menuItem.style.setProperty('width', '100%', 'important');
        menuItem.style.setProperty('max-width', '100%', 'important');
        menuItem.style.setProperty('box-sizing', 'border-box', 'important');
        menuItem.style.setProperty('gap', '14px', 'important');
        menuItem.style.setProperty('min-height', '55px', 'important');
        menuItem.style.setProperty('padding-top', '7px', 'important');
        menuItem.style.setProperty('padding-bottom', '7px', 'important');
        menuItem.style.setProperty('overflow', 'hidden', 'important');
        menuItem.style.setProperty('border-bottom', '1px solid rgba(75, 46, 62, 0.22)', 'important');

        label.style.setProperty('flex', '1 1 auto', 'important');
        label.style.setProperty('min-width', '0', 'important');
        label.style.setProperty('width', 'auto', 'important');
        label.style.setProperty('max-width', 'none', 'important');
        label.style.setProperty('overflow-wrap', 'anywhere', 'important');
        label.style.setProperty('font-size', '14px', 'important');
        label.style.setProperty('font-weight', '600', 'important');
        label.style.setProperty('letter-spacing', '0.12em', 'important');
        label.style.setProperty('line-height', '1.2', 'important');
        menuItem.dataset.orlMobileImageApplied = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addMobileMenuImages, { once: true });
    } else {
      addMobileMenuImages();
    }

    window.addEventListener('resize', addMobileMenuImages);
    document.addEventListener('shopify:section:load', addMobileMenuImages);
    document.addEventListener('shopify:section:reorder', addMobileMenuImages);
  })();

class StickyHeader extends HTMLElement {



    constructor() {



      super();



      this.setHeaderHeight = this.setHeaderHeight.bind(this);



    }







    connectedCallback() {



      this.header = document.querySelector('.section-header');



      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');



      this.headerIsAlwaysSticky =



        this.getAttribute('data-sticky-type') === 'always' ||



        this.getAttribute('data-sticky-type') === 'reduce-logo-size';



      this.headerBounds = {};







      this.setHeaderHeight();







      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);







      if (this.headerIsAlwaysSticky) {



        this.header.classList.add('shopify-section-header-sticky');



      }







      this.currentScrollTop = 0;



      this.preventReveal = false;



      this.predictiveSearches = this.querySelectorAll('predictive-search');







      this.onScrollHandler = this.onScroll.bind(this);



      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);







      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.addEventListener('scroll', this.onScrollHandler, false);







      this.createObserver();



    }







    setHeaderHeight() {



      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);



    }







    disconnectedCallback() {



      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);



      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.removeEventListener('scroll', this.onScrollHandler);



    }







    createObserver() {



      let observer = new IntersectionObserver((entries, observer) => {



        this.headerBounds = entries[0].intersectionRect;



        observer.disconnect();



      });







      observer.observe(this.header);



    }







    onScroll() {



      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;







      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;







      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (this.preventHide) return;



        requestAnimationFrame(this.hide.bind(this));



      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (!this.preventReveal) {



          requestAnimationFrame(this.reveal.bind(this));



        } else {



          window.clearTimeout(this.isScrolling);







          this.isScrolling = setTimeout(() => {



            this.preventReveal = false;



          }, 66);







          requestAnimationFrame(this.hide.bind(this));



        }



      } else if (scrollTop <= this.headerBounds.top) {



        this.header.classList.remove('scrolled-past-header');



        requestAnimationFrame(this.reset.bind(this));



      }







      this.currentScrollTop = scrollTop;



    }







    hide() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');



      this.closeMenuDisclosure();



      this.closeSearchModal();



    }







    reveal() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-sticky', 'animate');



      this.header.classList.remove('shopify-section-header-hidden');



    }







    reset() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');



    }







    closeMenuDisclosure() {



      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');



      this.disclosures.forEach((disclosure) => disclosure.close());



    }







    closeSearchModal() {



      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');



      this.searchModals.forEach((searchModal) => searchModal.close(false));



    }



  }







  // The account `open` event is composed but does not bubble, so listen during capture.



  // Anchor the dialog to the bottom of the account button itself. The header group can be



  // much taller than the button's row (for example, a top-left logo pushes the menu to a



  // second row), so anchoring to the section bottom drops the dialog too low.



  document.addEventListener(



    'open',



    (event) => {



      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;







      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));



      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);



    },



    true



  );







  customElements.define('sticky-header', StickyHeader);




  } catch(e) { console.error(e); }
})();
})();
